<template>
  <div class="detail">
    <div class="detail-header">
      <seckill-item
        :item="itemDetail"
        :source="'detail'"
        :stylecolor="styleColor"
        :isself="self"
        @viewApplyDetail="viewApplyDetail"
        v-if="itemDetailFlag"
      ></seckill-item>
    </div>
    <div class="detail-body">
      <div class="info-item disFlex fc">
        <div class="info-title">品牌：</div>
        <div class="info-content">{{itemDetail.brandName}}</div>
      </div>
      <div class="info-item disFlex fc">
        <div class="info-title">规格：</div>
        <div class="info-content">{{itemDetail.specs}}</div>
      </div>
      <div class="info-item" v-if="itemDetail.description">
        <div class="info-title">商品描述：</div>
        <div class="info-content html-content desc-content" v-html="itemDetail.description"></div>
      </div>
    </div>

    <div class="interact-box">
      <div
        class="interact-area f fvc v"
        v-if="itemDetail.status!=='no_start'&&itemDetail.status!=='applied'"
      >
        <!-- 已经领取秒杀 -->
        <img
          src="https://j.weizan.cn/youxiang/task-tip.png"
          class="task-tip"
          v-if="self&&itemDetail.status==='sharing'"
        />

        <!-- 好友正在参加 -->
        <div class="joining-tip f fc" v-if="!self&&itemDetail.sharer">
          <img src="https://j.weizan.cn/youxiang/haoyou.png" class="task-tip1" />
          <div class="name">{{itemDetail.sharer.nickname}}</div>
          <img src="https://j.weizan.cn/youxiang/miaoshaing.png" class="task-tip2" />
        </div>

        <!-- 完成秒杀任务 -->
        <img
          src="https://j.weizan.cn/youxiang/finish-miaosha.png"
          class="task-tip3"
          v-if="itemDetail.status==='help_success'&&itemDetail.assist>0&&self"
        />
        <!-- 成功购买 -->
        <img
          src="https://j.weizan.cn/youxiang/buyed-miaosha.png"
          class="task-tip4"
          v-if="itemDetail.status==='success'&&self"
        />

        <div class="schedule" v-if="itemDetail.helpUser&&itemDetail.assist>0">
          互动完成进度：{{itemDetail.helpUser.length}}/{{itemDetail.assist}}
          <div
            class="passed"
            :style="{'width':`calc(9.2rem * ${itemDetail.helpUser.length/itemDetail.assist})`}"
          ></div>
        </div>
        <div
          class="friends-area f fc fvc Flex-wrap"
          v-if="itemDetail.helpUser&&itemDetail.helpUser.length>0"
        >
          <div
            class="friend-item f v fvc"
            v-for="(item,index) in itemDetail.helpUser"
            :key="index"
            v-show="item"
          >
            <img :src="item.avatar" class="avatar" />
            <div class="friend-name clamp1">{{item.nickname}}</div>
          </div>
        </div>
        <div v-if="itemDetail.helpUser&&itemDetail.helpUser.length.length===0" class="f fvc v">
          <img src="https://j.weizan.cn/youxiang/empty-interact.png" class="empty-interact" />
          <div class="invite-tip">暂无互动，快去邀请好友吧~</div>
        </div>
      </div>
      <!-- 秒杀规则 -->
      <div>
        <div v-if="itemDetail.seckillAct" class="rule-area">
          <div
            class="html-content rule-content"
            v-if="itemDetail.seckillAct.prompt"
            v-html="itemDetail.seckillAct.prompt"
          ></div>
        </div>
        <div class="f fvc v" v-if="itemDetail.seckillAct&&itemDetail.seckillAct.logo">
          <img :src="itemDetail.seckillAct.logo" class="rule-pic" />
          <div class="rule-tip">扫码进群领好礼</div>
        </div>
      </div>
    </div>

    <div class="detail-footer f fc frd">
      <div class="f v fvc" @click="backHome">
        <img src="https://j.weizan.cn/youxiang/back-pic.png" class="back-pic" />
        <div class="back-tip">返回首页</div>
      </div>
      <div>
        <div v-if="self">
          <div
            class="buy-btn"
            :class="{'red-bgc':styleColor}"
            @click="joinSeckill"
            v-if="itemDetail.status==='no_start'"
          >参加秒杀活动</div>
          <div
            class="buy-btn"
            :class="{'red-bgc':styleColor}"
            v-else-if="itemDetail.status==='finish'"
          >活动已结束</div>
          <div
            class="buy-btn"
            :class="{'red-bgc':styleColor}"
            v-else-if="itemDetail.status==='sellout'"
          >已抢完</div>

          <div
            class="buy-btn"
            :class="{'red-bgc':styleColor}"
            v-else-if="itemDetail.status==='sharing'"
          >秒杀任务进行中</div>
          <div
            class="buy-btn"
            :class="{'red-bgc':styleColor}"
            v-else-if="itemDetail.status==='help_success'"
            @click="buyNow"
          >支付购买</div>
          <div
            class="buy-btn"
            :class="{'red-bgc':styleColor}"
            v-else-if="itemDetail.status==='success'"
            @click="getQrCode"
          >去核销</div>
          <div
            class="buy-btn"
            :class="{'red-bgc':styleColor}"
            v-else-if="itemDetail.status==='applied'"
            @click="viewApplyDetail"
          >查看详情</div>
        </div>

        <div class="btn-box disFlex fc fbt" v-if="!self&&itemDetail.status!=='no_start'">
          <div
            class="op-btn deep-bg"
            @click="helpFriend"
            v-if="!itemDetail.helpStatus&&(itemDetail.helpCount<itemDetail.assist)"
          >帮好友助力</div>
          <div class="op-btn deep-bg" v-else>助力成功</div>

          <div class="op-btn" @click="wantSeckill">我也要秒杀</div>
        </div>
        <div class="btn-box disFlex fc fbt" v-if="!self&&itemDetail.status=='no_start'">
          <div class="buy-btn" @click="wantSeckill">我也要秒杀</div>
        </div>
      </div>
    </div>

    <div class="share-toast" @click="shareToast = false" v-if="shareToast">
      <img src="https://j.weizan.cn/youxiang/share-img.png" class="share-img" />
    </div>
    <van-dialog
      v-model="helpDialog"
      :close-on-click-overlay="true"
      confirm-button-text="我也要秒杀"
      @confirm="wantSeckill"
    >
      <div class="help-dialog f fvc v" v-if="helpDialog">
        <div>
          恭喜您成功助力好友
          <img :src="itemDetail.sharer.avatar" class="avatar" />
          {{itemDetail.sharer.nickname}}
        </div>
        <div class="tip">您已获得参与秒杀活动的机会，点击下方立即参与活动</div>
      </div>
    </van-dialog>
    <van-dialog v-model="qrcodeFlag" :close-on-click-overlay="true" :show-confirm-button="false">
      <div style="width:80%;margin:10px auto">
        <img :src="qrcode" style="width:100%" alt="图片加载中，请稍后" />
        <div class="tip">出示给导购员进行扫码核销</div>
      </div>
    </van-dialog>
    <!--  -->
    <div v-if="seckillSignupFlag">
      <seckill-signup
        @closeSignup="closeSeckillSignup"
        @signupSuccess="seckillSignupSuccess"
        :enrollNum="enrollNum"
        :status="seckillActInfo.status"
        :startTime="seckillActInfo.startTime"
        :endTime="seckillActInfo.endTime"
        :productNum="seckillActInfo.productNum"
        :item="itemDetail"
      ></seckill-signup>
    </div>
    <!--滑块验证码-->
    <div id="imgscode" ref="imgscode" @touchmove.prevent></div>
  </div>
</template>

<script>
import SeckillItem from "./../../components/seckill-item";
import SeckillSignup from "./../../components/seckill-signup";
export default {
  components: {
    SeckillItem,
    SeckillSignup,
  },
  data() {
    return {
      seckillId: this.$route.query.id,
      itemDetail: {},
      shareToast: false,
      self: Boolean(this.$route.query.self || false), // 是否正常跳转过来的自己的页面
      helpDialog: false, //助力成功弹窗
      qrcodeFlag: false,
      qrcode: "",
      seckillSignupFlag: false,
      seckillActInfo: null,
      enrollNum: 0,
      itemDetailFlag: false,
      enrollStatus: localStorage.getItem("setEnrollStatus"),
      seckillItem: JSON.parse(localStorage.getItem("setSecKillItem")),
      styleColor: true, //页面风格默认红色
    };
  },
  computed: {
    // ...mapState(["enrollStatus", "seckillItem"]),
  },
  created() {
    this.$store.commit("setLoading", false);
    if (this.$route?.query?.share_user_id === localStorage.getItem("user_id")) {
      this.self = true;
    }
    this.getSeckillDetail().then((res) => {
      this.$initWXSDK(
        {
          openShare: true,
        },
        () => {
          this.$utils.getLocation();
        },
        {
          shareInfo: {
            data: JSON.stringify({
              linkTitle: res.seckillAct.shareTitle,
              linkDesc: res.seckillAct.shareDesc,
              linkPoster: res.seckillAct.shareLogo,
            }),
          },
          isSeckill: true,
        }
      );
      // 获取秒杀活动信息
      this.getSeckillList();
      this.getActInfo();
    });
  },
  methods: {
    getActInfo() {
      this.$http.post("/v1/home/activity").then((res) => {
        if (res.code === 0) {
          this.styleColor = res.data.style == "red" ? true : false;
        }
      });
    },
    // 未报名组件使用方法
    // 关闭
    closeSeckillSignup() {
      this.seckillSignupFlag = false;
      this.$txLogs({
        bpm: "3.seckill_cancle",
      });
    },
    // 报名成功
    seckillSignupSuccess() {
      // this.$store.commit("setEnrollStatus", "enrolled");
      localStorage.setItem("setEnrollStatus", "enrolled");
      this.enrollStatus = "enrolled";
      this.seckillSignupFlag = false;
      this.$toast("报名成功");
      this.$txLogs({
        bpm: "3.seckill_enrollment",
      });
    },
    // 获取秒杀活动内容
    async getSeckillList() {
      let list = await this.$http.post("/v1/seckill/product/static/list", {
        page: this.currentSeckillPage,
        size: 1,
      });
      this.seckillActInfo = list?.data?.seckillAct;
    },

    viewApplyDetail() {
      const that = this;
      that.$dialog({
        title: "使用详情",
        message: `核销时间：${that.itemDetail.finishTime}\n\n核销员工：${
          that.itemDetail.kpiUserName || "-"
        }\n\n核销门店：${that.itemDetail.kpiUserShop || "-"}\n\n核销品牌：${
          that.itemDetail.kpiUserBrand || "-"
        }\n\n`,
      });
    },
    getQrCode() {
      this.$http
        .get("/v1/qrcode/gen_code", {
          scene: "seckill_order_finish",
          addition: encodeURIComponent(
            JSON.stringify({
              id: this.seckillId,
              tradeNo: this.itemDetail.tradeNo,
            })
          ),
        })
        .then((res) => {
          if (res.code === 0) {
            this.qrcode = res.data.qrcodePath;
            this.qrcodeFlag = true;
          }
        });
    },
    helpFriend() {
      // 此处进行验证码判定
      var self = this;
      console.log(this.$refs.imgscode);
      $("#imgscode").imgcode({
        frontimg:
          "https://yx-image-1251575313.cos.ap-guangzhou.myqcloud.com/dev/upload/image/2020/08/26/ffb6cb3da70047f980011b2d2ff6383f.jpg",
        backimg:
          "https://yx-image-1251575313.cos.ap-guangzhou.myqcloud.com/dev/upload/image/2020/08/26/4b6da1fda5174f44aafa0634442aa962.jpg",
        refreshcallback: function () {
          console.log(114);
          self.helpFriend();
        },
        callback: function (msg) {
          console.log(514);
          self.chkVerCode(this, msg, 13420191150);
        },
      });
    },
    chkVerCode($verObj, msg, Phone) {
      var self = this;
      console.log(msg);
      // 根据验证码的接口判断
      if (msg.xpos <= 220 && msg.xpos >= 205) {
        $verObj.getsuccess("验证成功");
        self.$http
          .post("/v1/seckill/task/help", {
            productId: self.seckillId,
          })
          .then((res) => {
            if (res.code === 0) {
              self.helpDialog = true;
              self.getSeckillDetail();
            }
          });
      } else {
        $verObj.getfail("验证失败，请重新验证");
      }
    },
    // 8.31二期优化，秒杀支付转移到seckillm秒杀详情中进行。
    joinSeckill() {
      this.$utils.checkEnroll().then(() => {
        // 判断当前用户是否已报名
        // 未报名跳转回preheat打开
        if (this.enrollStatus !== "enrolled") {
          this.$toast("请先报名");
          this.seckillSignupFlag = true;
          return false;
        }
        if (this.seckillActInfo.productNum == 0) {
          this.$txLogs({
            bpm: "3.seckill_join",
          });
          // 检查秒杀次数
          this.checkedNum();
        } else {
          this.$dialog({
            showCancelButton: true,
            messageAlign: "left",
            message: `• 每个用户仅限购买${this.seckillActInfo.productNum}款秒杀商品，您确定要秒杀这件商品吗？\n\n• 您即将参与秒杀商品抢购，秒杀商品为限量产品，秒完即止，请随时关注页面剩余数量`,
          })
            .then(() => {
              // 开始秒杀活动任务转移至确认参与秒杀抢购中
              this.$txLogs({
                bpm: "3.seckill_join",
              });
              // 检查秒杀次数
              this.checkedNum();
            })
            .catch(() => {
              this.$txLogs({
                bpm: "3.seckill_cancle",
              });
            });
        }
      });
    },
    buyNow() {
      this.$txLogs({
        bpm: "3.seckill_pay",
      });
      var self = this;
      this.$http
        .post("/v1/pay/create_order", {
          orderType: "seckill",
          productId: this.seckillId,
        })
        .then((result) => {
          console.log(result);
          if (result.data && result.code == 0) {
            let tmp = {
              appId: result.data.appId, //公众号名称，由商户传入
              timeStamp: result.data.timeStamp, //时间戳，自1970年以来的秒数
              nonceStr: result.data.nonceStr, //随机串
              package: result.data.packageValue,
              signType: result.data.signType, //微信签名方式：
              paySign: result.data.paySign, //微信签名
            };
            self.wechatPay(tmp);
          } else if (result.code == 20706) {
            self.$toast(result.msg);
            // 充值成功且微信回调慢，禁止支付，刷新一次
            window.location.reload();
          }else{
            self.$toast(result.msg);
          }
        });
    },
    wechatPay(json) {
      const that = this;
      try {
        if (typeof WeixinJSBridge !== "undefined") {
          WeixinJSBridge.invoke("getBrandWCPayRequest", json, (res) => {
            if (res.err_msg === "get_brand_wcpay_request:ok") {
              that.$toast("支付成功！");
              that.getSeckillDetail();
              // location.reload();
            }
          });
        } else {
          that.$toast("请使用微信支付");
        }
      } catch (e) {
        that.$toast("服务器繁忙，请稍后再试");
      }
    },
    checkedNum() {
      this.$http
        .post("/v1/seckill/task/pre_start", {
          productId: this.seckillItem.id,
        })
        .then((res) => {
          if (res.code === 0) {
            // 开始秒杀任务
            this.startTask();
          }
        });
    },
    startTask() {
      this.$http
        .post("/v1/seckill/task/start", {
          productId: this.seckillId,
        })
        .then((res) => {
          this.getSeckillDetail();
          if (this.itemDetail.assist !== 0) {
            // this.shareToast = true;
          }
        });
    },
    getSeckillDetail() {
      return new Promise(async (resolve) => {
        let detail = await this.$http.post("/v1/seckill/product/detail", {
          productId: this.seckillId,
          self: this.self ? true : false,
          showHelp: true,
        });
        this.$store.commit("setLoading", false);

        if(detail.msg=="秒杀商品不存在"){
          this.$toast("该商品已下架，去主页看看其他商品吧~");
          setTimeout(() => {
            let tmp = localStorage.getItem("preheatPath") || "prehddd";
            this.$router.push({
              path: tmp,
              query: {
                act_id: this.$route.query.act_id || localStorage.getItem("act_id"),
              },
            });
          }, 3000);
        }
        this.itemDetail = detail.data;
        this.itemDetailFlag = true;
        resolve(detail.data);
      });
    },
    backHome() {
      this.$txLogs({
        bpm: "3.go_home",
      });

      let tmp = localStorage.getItem("preheatPath") || "prehddd";
      this.$router.push({
        path: tmp,
        query: {
          act_id: this.$route.query.act_id || localStorage.getItem("act_id"),
        },
      });
    },
    wantSeckill() {
      let tmp = localStorage.getItem("preheatPath") || "prehddd";

      this.$router.push({
        path: tmp,
        query: {
          scrollToSeckill: true,
          act_id: this.$route.query.act_id || localStorage.getItem("act_id"),
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.red-bgc {
  background: #b80000 !important;
}
.red-bgc-light {
  background: rgba(184, 0, 0, 0.6) !important;
}
.red-c {
  color: #b80000 !important;
}
.white-c {
  color: #ffffff !important;
}
.red-linear {
  background: linear-gradient(90deg, #9b0000, #b80000, #9b0000) !important;
}
.red-boxs {
  box-shadow: 0px 10px 11px 0px rgba(184, 0, 0, 0.68) !important;
}
.detail {
  padding-bottom: 75px;
  /deep/ .van-dialog{
    top:52%;
  }
  .detail-header {
    padding: 0 15px;
    background: #fff;
  }
  .detail-body {
    padding: 15px;
  }

  .detail-footer {
    position: fixed;
    left: 0;
    bottom: 0;
    background: #fff;

    height: 60px;
    width: 100%;
  }
  .back-pic {
    width: 22px;
    height: 22px;
    margin-bottom: 7px;
  }
  .back-tip {
    font-size: 12px;
    font-family: PingFang SC;
    font-weight: bold;
    color: rgba(53, 53, 53, 1);
  }
  .buy-btn {
    width: 280px;
    height: 44px;
    background: rgba(0, 48, 120, 1);
    border-radius: 22px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: bold;
    color: rgba(255, 255, 255, 1);
    line-height: 44px;
    text-align: center;
  }
  .btn-box {
    width: 280px;
    .op-btn {
      width: 133px;
      height: 44px;
      border: 1px solid rgba(0, 48, 120, 1);
      border-radius: 22px;
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: bold;
      color: rgba(0, 48, 120, 1);
      line-height: 44px;
      text-align: center;
    }
    .deep-bg {
      background: rgba(0, 48, 120, 1);
      color: rgba(255, 255, 255, 1);
      border: none;
    }
  }
  .info-item {
    font-size: 12px;
    font-family: PingFang SC;
    font-weight: 500;
    color: rgba(53, 53, 53, 1);
    line-height: 24px;
    .info-title {
      width: 62px;
    }
  }

  .interact-box {
    width: 100%;
    background: linear-gradient(
      180deg,
      rgba(0, 48, 120, 0.08),
      rgba(255, 255, 255, 0.1)
    );
    border-radius: 16px 16px 0px 0px;
    padding: 18px;
  }
  .tixing {
    width: 60px;
    height: 10px;
    background: #f2f3f9;

    transform: perspective(0.5em) rotateX(5deg);
    transform-origin: bottom;
    left: 158px;
    position: relative;
  }
  .blue-down-arrow {
    width: 16px;
    height: 4px;
    position: relative;
    top: 22px;
    left: 180px;
    z-index: 1;
  }
  .interact-area {
    width: 100%;
    .task-tip {
      width: 132px;
      height: 13px;
      margin: 13px 0 27px;
    }
    .joining-tip {
      margin: 13px 0 27px;
    }

    .task-tip1 {
      width: 33px;
      height: 13px;
    }
    .task-tip2 {
      width: 99px;
      height: 13px;
    }
    .task-tip3 {
      width: 132px;
      height: 13px;
      margin: 13px 0 27px;
    }
    .task-tip4 {
      width: 182px;
      height: 13px;
      margin: 13px 0 27px;
    }
    .name {
      height: 20px;
      background: rgba(0, 48, 120, 0.2);
      border-radius: 4px;
      padding: 0 7px;
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: bold;
      color: rgba(0, 48, 120, 1);
      line-height: 20px;
      margin: 0 5px;
    }
    .schedule {
      font-size: 12px;
      font-family: PingFang SC;
      font-weight: 500;
      color: rgba(0, 48, 120, 1);
      width: 345px;
      height: 32px;
      line-height: 32px;
      text-align: center;
      border: 1px solid rgba(0, 48, 120, 0.1);
      border-radius: 5px;
      overflow: hidden;
      position: relative;
      .passed {
        position: absolute;
        left: 0;
        top: 0;
        height: 32px;
        background: rgba(0, 48, 120, 0.1);
      }
    }

    .friends-area {
      width: 100%;
      margin: 20px 0 0;
      .friend-item {
        width: 40px;
        margin: 0 10px;
        margin-bottom: 15px;
        .avatar {
          width: 40px;
          height: 40px;
          border-radius: 50%;
          margin-bottom: 10px;
        }
        .friend-name {
          font-size: 12px;
          line-height: 14px;
          font-family: PingFang SC;
          font-weight: 500;
          color: rgba(53, 53, 53, 1);
        }
      }
    }
    .empty-interact {
      width: 75px;
      height: 127px;
    }
    .invite-tip {
      font-size: 12px;
      font-family: PingFang SC;
      font-weight: 500;
      color: rgba(116, 116, 116, 0.45);
      margin-top: 3px;
    }
  }
  .share-toast {
    width: 100vw;
    height: 100vh;
    position: fixed;
    left: 0;
    top: 0;
    background: rgba(8, 8, 8, 0.3);
    z-index: 20;
    .share-img {
      width: 251px;
      height: 87px;
      position: absolute;
      top: 10px;
      right: 15px;
    }
  }
  .help-dialog {
    font-size: 16px;
    text-align: center;
    padding: 20px;
    .tip {
      margin-top: 20px;
      line-height: 20px;
    }
  }
  .avatar {
    width: 30px;
    height: 30px;
    margin: 0 5px;
    border-radius: 50%;
  }

  .rule-content {
    text-align: center;
    margin: 0 0 20px 0;
  }
  .rule-tip {
    font-size: 12px;
    font-family: PingFang SC;
    font-weight: 500;
    color: rgba(53, 53, 53, 1);
    margin-top: 10px;
  }
  .rule-pic {
    width: 98px;
    height: 98px;
  }
  .rule-area {
    margin-top: 20px;
  }
}
</style>